


export enum CheckTypeEnum {
	some = 'some',
	all = 'all',
	none = 'none',
}